module.exports = __webpack_public_path__ + "assets/img/flexible_vector.67c3b98f.svg";